// extracted by mini-css-extract-plugin
module.exports = {"list":"ruleSort_list__1x7cI","placeHolder":"ruleSort_placeHolder__M_PHb"};